export default {
  wrapper: {
    m: 0,
    width: '100%',
  },
  radioIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  radioUncheckedIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.grays?.gray300,
  },
  textfield: {
    width: '100%',
    height: '100%',
    borderWidth: 0,
    boxShadow: 'none',
    fontSize: '0.875rem',
    backgroundColor: '#fff',
    '& .MuiSvgIcon-root': {
      display: 'none',
    },
    '& .MuiSvgIcon-root.MuiSelect-iconOutlined': {
      display: 'block',
    },
    '& .MuiInputLabel-root[data-shrink="true"]': {
      color: (theme) => theme.palette.blues.primaryBlue500,
      backgroundColor: '#fff',
      zIndex: 999,
      padding: '0 4px',
    },
    color: (theme) => theme.palette.grays.gray700,
    '& .MuiSelect-nativeInput': {
      border: 'none',
      height: '100%',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
    },
    '& .MuiSelect-select': {
      fontSize: '0.875rem',
      display: 'flex',
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 1,
      top: 0,
      height: '40px',
      borderColor: (theme) => `${theme.palette.grays.gray300}`,
      legend: {
        display: 'none',
      },
    },
    '& .MuiInputBase-root': {
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: (theme) => `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: (theme) => theme.palette.grays.gray700,
          backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
        },
      },
    },
    '& .Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        border: 1,
        borderColor: (theme) => `${theme.palette.grays.gray300}`,
      },
      '& .MuiInputBase-input': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
    },
    '& .Mui-error': {
      '.MuiOutlinedInput-notchedOutline': {
        boxShadow: (theme) => `${theme.customShadows.errorShadow}`,
        borderColor: (theme) => `${theme.palette.reds.codingRed200}!important`,
      },
      '&.Mui-focused': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
      '&:hover': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
    },
    '& .Mui-disabled': {
      opacity: 0.8,
      color: (theme) => theme.palette.grays.gray700,
      pointerEvents: 'none',
      '&:hover': {
        backgroundColor: 'transparent!important',
        pointerEvents: 'none',

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: (theme) => `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
};
